<template>
  <div>
    <h1 class="mb-0">{{ $t("public.views.signUp.title") }}</h1>
    <p>
      {{ $t("public.views.signUp.text") }}
    </p>
    <b-form class="form-auth-pages">
      <b-form-group label="Email: *" label-for="email">
        <b-form-input v-model="email" type="text" v-bind:class="{
            'text-danger': isFormEmailErrors,
            'is-invalid': isFormEmailErrors,
          }" @blur="checkEmail(email, emailInUse)"></b-form-input>
        <ul v-if="isFormEmailErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('email')" v-bind:key="index"
            class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="password">
        <template slot="label">{{ $t("public.views.signUp.pwd") }}: *</template>
        <b-form-input id="password" v-model="password" type="password" v-bind:class="{
            'text-danger': isFormPasswordErrors,
            'is-invalid': isFormPasswordErrors,
          }" @blur="checkPassword(password)"></b-form-input>
        <ul v-if="isFormPasswordErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('password')" v-bind:key="index"
            class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="passwordConfirm">
        <template slot="label">{{ $t("public.views.signUp.pwdConfirm") }}: *
        </template>
        <b-form-input id="passwordConfirm" v-model="passwordConfirm" type="password" v-bind:class="{
            'text-danger': isFormPasswordConfirmErrors,
            'is-invalid': isFormPasswordConfirmErrors,
          }" @blur="checkPasswordConfirm(passwordConfirm, password)"></b-form-input>
        <ul v-if="isFormPasswordConfirmErrors">
          <li v-for="(error, index) in validatorStep1.getErrors(
            'passwordConfirm'
          )" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <div class="sign-info">
        <span class="dark-color d-inline-block line-height-2">
          {{ $t("public.views.signIn.activateAcount.text") }}
          <router-link class="iq-waves-effect pr-4" to="/public/activateAccount">{{
            $t("public.views.signIn.activateAcount.go")
          }}</router-link>
        </span>
      </div>
      <b-button ref="btnVolver" class="btn-margin float-right ml-2" variant="primary" @click="routeBack">{{
        $t("public.views.signUp.btnBack")
      }}
      </b-button>
      <b-button ref="btnShowCitaCrear" class="btn-margin float-right ml-2" variant="success" @click="saveFormStep1">{{
        $t("public.views.signUp.btnCreate")
      }}
      </b-button>
    </b-form>
    <b-modal id="modal-register" centered size="lg" @close="hideActionStep2" @ok="saveFormStep2">
      <template #modal-title>{{
        $t("public.views.signUp.modalCreate.title")
      }}
      </template>
      <template #modal-ok>{{
        $t("public.views.signUp.modalCreate.btnCreate")
      }}
      </template>
      <template #modal-cancel>{{
        $t("public.views.signUp.modalCreate.btnClose")
      }}
      </template>
      <form action="#">
        <b-form-group label-for="name">
          <template slot="label">
            <div>
              {{ $t("public.views.signUp.modalCreate.nameProfessional") }}: *
            </div>
          </template>
          <b-form-input id="nombre" v-model="name" type="text" v-bind:class="{
              'text-danger': isFormNameErrors,
              'is-invalid': isFormNameErrors,
            }" @blur="checkName(name)"></b-form-input>
          <ul v-if="isFormNameErrors">
            <li v-for="(error, index) in validatorStep2.getErrors('name')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="lastname">
          <template slot="label">{{ $t("public.views.signUp.modalCreate.lastname") }}: *
          </template>
          <b-form-input id="lastname" v-model="lastname" type="text" v-bind:class="{
              'text-danger': isFormLastnameErrors,
              'is-invalid': isFormLastnameErrors,
            }" @blur="checkLastname(lastname)"></b-form-input>
          <ul v-if="isFormLastnameErrors">
            <li v-for="(error, index) in validatorStep2.getErrors('lastname')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>

        <b-form-group label-for="document">
          <template slot="label">{{ $t("public.views.signUp.modalCreate.document") }}: *
          </template>
          <b-form-input id="document" v-model="document" type="text" v-bind:class="{
              'text-danger': isFormDocumentErrors,
              'is-invalid': isFormDocumentErrors,
            }" @blur="checkDocument(document)"></b-form-input>
          <ul v-if="isFormDocumentErrors">
            <li v-for="(error, index) in validatorStep2.getErrors('document')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <div class="row">
          <div class="col-md-8">
            <b-form-group>
              <template slot="label">
                <div>
                  {{ $t("public.views.signUp.modalCreate.imagePicture") }}:
                </div>
              </template>
              <vue-dropzone id="picture" :options="dropzoneOptions" @vdropzone-success="vdropzoneSuccess"></vue-dropzone>
            </b-form-group>
          </div>
          <div class="col-md-4 img-center">
            <img v-if="defaultAvatar" :src="file" class="img-fluid rounded mr-3" height="150px" width="150px" />
            <img v-else class="img-fluid rounded mr-3" height="150px" v-bind:src="'data:image/jpeg;base64,' + file"
              width="150px" />
          </div>
        </div>
        <b-form-group label-for="idioma">
          <template slot="label">{{ $t("public.views.signUp.modalCreate.lenguaje") }}:
          </template>
          <b-select id="language" v-model="language" :options="languageSelect" class="form-control" v-bind:class="{
              'text-danger': isFormLanguageErrors,
              'is-invalid': isFormLanguageErrors,
            }">
          </b-select>
          <ul v-if="isFormLanguageErrors">
            <li v-for="(error, index) in validatorStep2.getErrors('language')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="phone">
          <template slot="label">{{ $t("public.views.signUp.modalCreate.tlf") }}:
          </template>
          <VuePhoneNumberInput id="phone" v-model="phoneVuePhoneNumberInput" :translations="translations"
            default-country-code="ES" v-bind:class="{
                'text-danger': isFormPhoneErrors,
                'is-invalid': isFormPhoneErrors,
              }" @update="updatePhone" />
          {{ phone }}
          <ul v-if="isFormPhoneErrors">
            <li v-for="(error, index) in validatorStep2.getErrors('phone')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="country">
          <template slot="label">{{ $t("public.views.signUp.modalCreate.country") }}: *
          </template>
          <b-form-input id="country" v-model="country" type="text" v-bind:class="{
              'text-danger': isFormCountryErrors,
              'is-invalid': isFormCountryErrors,
            }" @blur="checkCountry(country)"></b-form-input>
          <ul v-if="isFormCountryErrors">
            <li v-for="(error, index) in validatorStep2.getErrors('country')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="address">
          <template slot="label">{{ $t("public.views.signUp.modalCreate.address") }}: *
          </template>
          <b-form-input id="address" v-model="address" type="text" v-bind:class="{
              'text-danger': isFormAddressErrors,
              'is-invalid': isFormAddressErrors,
            }" @blur="checkAddress(address)"></b-form-input>
          <ul v-if="isFormAddressErrors">
            <li v-for="(error, index) in validatorStep2.getErrors('address')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="timeZone">
          <template slot="label">{{ $t("public.views.signUp.modalCreate.timeZone") }}:
          </template>
          <b-select id="timeZone" v-model="timeZone" :options="timeZoneSelect" class="form-control" v-bind:class="{
              'text-danger': isFormTimeZoneErrors,
              'is-invalid': isFormTimeZoneErrors,
            }">
          </b-select>
          <ul v-if="isFormTimeZoneErrors">
            <li v-for="(error, index) in validatorStep2.getErrors('timeZone')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="currency">
          <template slot="label">{{ $t("public.views.signUp.modalCreate.currency") }}:
          </template>
          <b-select id="currency" v-model="currency" :options="currencySelect" class="form-control" v-bind:class="{
              'text-danger': isFormCurrencyErrors,
              'is-invalid': isFormCurrencyErrors,
            }">
          </b-select>
          <ul v-if="isFormCurrencyErrors">
            <li v-for="(error, index) in validatorStep2.getErrors('currency')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="memberId">
          <template slot="label">{{ $t("public.views.signUp.modalCreate.memberId") }}: *
          </template>

          <b-form-input id="memberId" v-model="memberId" type="text" v-bind:class="{
              'text-danger': isFormMemberIdErrors,
              'is-invalid': isFormMemberIdErrors,
            }" @blur="checkMemberId(memberId)"></b-form-input>
          <ul v-if="isFormMemberIdErrors">
            <li v-for="(error, index) in validatorStep2.getErrors('memberId')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="acceptConditions">
          <template slot="label"></template>
          <b-form-checkbox id="acceptConditions" v-model="acceptConditions" unchecked-value="false" value="true"
            @blur="checkAcceptConditions(acceptConditions)">
            <a class="cursor-point" @click="openConditions">
              {{ $t("public.views.signUp.modalCreate.acceptConditions") }}
            </a>
          </b-form-checkbox>
          <ul v-if="isFormAcceptConditionsErrors">
            <li v-for="(error, index) in validatorStep2.getErrors(
              'acceptConditions'
            )" v-bind:key="index" class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
      </form>
    </b-modal>
    <notifications group="notificacions" />
  </div>
</template>
<script>
//JSON Mock
import TimeZone from "../../services/timeZone";
import Language from "../../json/Language";
import Currency from "../../json/Currency";

import routes from "../../router/index";

import validator from "vue-m-validator";

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import professionalService from "../../services/professional";
import utilsService from "../../services/utils";

export default {
  name: "SignUp",
  components: {
    VuePhoneNumberInput,
    "vue-dropzone": vue2Dropzone,
  },
  data() {
    return {
      //Data validate form
      isFirstRun: true,
      isValidateStep1: false,
      isValidateStep2: false,
      //Form registrate
      emailInUse: false,
      email: "",
      password: "",
      passwordConfirm: "",
      tokenRecaptcha: "",
      //--
      //Form modal
      name: "",
      lastname: "",
      document: "",
      language: "sp",
      address: "",
      uuid: "",
      filename: "",
      phone: "",
      phoneVuePhoneNumberInput: "",
      country: "",
      timeZone: "Europe/Brussels",
      currency: "EUR",
      memberId: "",
      acceptConditions: "false",
      state: "disabled",
      //--
      //Form image
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL_CORE + "public/avatar/upload",
        thumbnailWidth: 200,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
      },
      //Phone
      translations: {
        countrySelectorLabel: this.$i18n.t(
          "generic.phone.countrySelectorLabel"
        ),
        countrySelectorError: this.$i18n.t(
          "generic.phone.countrySelectorError"
        ),
        phoneNumberLabel: this.$i18n.t("generic.phone.phoneNumberLabel"),
        example: this.$i18n.t("generic.phone.example"),
      },
      //--
      //Load select
      timeZoneSelect: TimeZone,
      currencySelect: Currency,
      languageSelect: Language,
      validatorStep1: validator,
      validatorStep2: validator,
      //Avatar
      file: "",
      defaultAvatar: true,
    };
  },
  mounted() {
    this.cleanFormStep1();
  },
  computed: {
    disabled() {
      return this.state === "disabled";
    },
    //Form step 1
    isFormEmailErrors() {
      const RULE_2_REGEXP = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      );
      if (RULE_2_REGEXP.test(this.email)) {
        this.getCheckEmail(this.email);
      }
      let errors = this.validatorStep1.getErrors("email");
      return errors && errors.length > 0;
    },
    isFormPasswordErrors() {
      let errors = this.validatorStep1.getErrors("password");
      return errors && errors.length > 0;
    },
    isFormPasswordConfirmErrors() {
      let errors = this.validatorStep1.getErrors("passwordConfirm");
      return errors && errors.length > 0;
    },
    //Form step 2
    isFormNameErrors() {
      let errors = this.validatorStep2.getErrors("name");
      return errors && errors.length > 0;
    },
    isFormLastnameErrors() {
      let errors = this.validatorStep2.getErrors("lastname");
      return errors && errors.length > 0;
    },
    isFormDocumentErrors() {
      let errors = this.validatorStep2.getErrors("document");
      return errors && errors.length > 0;
    },
    isFormCurrencyErrors() {
      let errors = this.validatorStep2.getErrors("currency");
      return errors && errors.length > 0;
    },
    isFormAcceptConditionsErrors() {
      let errors = this.validatorStep2.getErrors("acceptConditions");
      return errors && errors.length > 0;
    },
    isFormMemberIdErrors() {
      let errors = this.validatorStep2.getErrors("memberId");
      return errors && errors.length > 0;
    },
    isFormAcceptConditionsErrors() {
      let errors = this.validatorStep2.getErrors("acceptConditions");
      return errors && errors.length > 0;
    },
    isFormLanguageErrors() {
      let errors = this.validatorStep2.getErrors("language");
      return errors && errors.length > 0;
    },
    isFormPhoneErrors() {
      let errors = this.validatorStep2.getErrors("phone");
      return errors && errors.length > 0;
    },
    isFormCountryErrors() {
      let errors = this.validatorStep2.getErrors("country");
      return errors && errors.length > 0;
    },
    isFormAddressErrors() {
      let errors = this.validatorStep2.getErrors("address");
      return errors && errors.length > 0;
    },
    isFormTimeZoneErrors() {
      let errors = this.validatorStep2.getErrors("timeZone");
      return errors && errors.length > 0;
    },
  },
  methods: {
    async recaptcha() {
      let self = this;
      this.$recaptchaLoaded()
        .then(() => {
          this.$recaptcha("register")
            .then((token) => {
              self.tokenRecaptcha = token;

              self.createProfessional();
            })
            .catch(function (error) {
              if (error.response && error.response.status === 404) {
                routes.push({ name: "public.signin" });
              } else if (error.response && error.response.status === 500) {
                routes.push({ name: "public.signin" });
              } else {
                routes.push({ name: "public.signin" });
              }
            });
        })
        .catch(function (error) {
          if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        });

      // Do stuff with the received token.
    },
    openConditions() {
      this.$refs.footer.openByTitle("Condiciones de uso y aviso legal");
    },
    routeBack() {
      this.$router.push({ name: "public.signin" });
    },
    hideActionStep2() {
      this.cleanFormStep1();
      this.cleanFormStep2();
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkEmail(_email, checkEmail) {
      const EMAIL = _email.trim();
      const RULE_1 = {
        expression: !EMAIL || EMAIL === "",
        name: "email",
        msg: this.$i18n.t("public.views.signUp.errors.erEmail1"),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(EMAIL),
        name: "email",
        msg: this.$i18n.t("public.views.signUp.errors.erEmail2"),
      };
      const RULE_3 = {
        expression: checkEmail,
        name: "email",
        msg: this.$i18n.t("public.views.signUp.errors.erEmail3"),
      };
      this.validatorStep1.addRule(RULE_1).addRule(RULE_2).addRule(RULE_3);
      this.notFirst();
    },
    checkPassword(_password) {
      const PASSWORD = _password.trim();
      const RULE_1 = {
        expression: !PASSWORD || PASSWORD === "",
        name: "password",
        msg: this.$i18n.t("public.views.signUp.errors.erPwd"),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        "^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Zd@$!%*#?&.]{6,}$"
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(PASSWORD),
        name: "password",
        msg: this.$i18n.t("public.views.signUp.errors.erPwd2"),
      };
      this.validatorStep1.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    checkPasswordConfirm(_passwordConfirm, _password) {
      const PASSWORDCONFIRM = _passwordConfirm.trim();
      const PASSWORD = _password.trim();
      const RULE_1 = {
        expression: !PASSWORDCONFIRM || PASSWORDCONFIRM === "",
        name: "passwordConfirm",
        msg: this.$i18n.t("public.views.signUp.errors.erPwdConfirm"),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        "^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Zd@$!%*#?&.]{6,}$"
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(PASSWORDCONFIRM),
        name: "passwordConfirm",
        msg: this.$i18n.t("public.views.signUp.errors.erPwd2"),
      };
      const RULE_3 = {
        expression: PASSWORDCONFIRM !== PASSWORD,
        name: "passwordConfirm",
        msg: this.$i18n.t("public.views.signUp.errors.erPwdConfirm2"),
      };
      this.validatorStep1.addRule(RULE_1).addRule(RULE_2).addRule(RULE_3);
      this.notFirst();
    },
    checkName(_name) {
      const NAME = _name.trim();
      const RULE_1 = {
        expression: !NAME || NAME === "",
        name: "name",
        msg: this.$i18n.t("public.views.signUp.errors.erName"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkLastname(_lastname) {
      const LASTNAME = _lastname.trim();
      const RULE_1 = {
        expression: !LASTNAME || LASTNAME === "",
        name: "lastname",
        msg: this.$i18n.t("public.views.signUp.errors.erLastName"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkDocument(_document) {
      const DOCUMENT = _document.trim();
      const RULE_1 = {
        expression: !DOCUMENT || DOCUMENT === "",
        name: "document",
        msg: this.$i18n.t("public.views.signUp.errors.erDocument"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkLanguage(_language) {
      const LANGUAGE = _language.trim();
      const RULE_1 = {
        expression: !LANGUAGE || LANGUAGE === "",
        name: "language",
        msg: this.$i18n.t("public.views.signUp.errors.erLenguage"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkPhone(_phone) {
      const PHONE = _phone.trim();
      const RULE_1 = {
        expression: !PHONE || PHONE === "",
        name: "phone",
        msg: this.$i18n.t("public.views.signUp.errors.erTlf"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkCountry(_country) {
      const COUNTRY = _country.trim();
      const RULE_1 = {
        expression: !COUNTRY || COUNTRY === "",
        name: "country",
        msg: this.$i18n.t("public.views.signUp.errors.erCountry"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkAddress(_address) {
      const ADDRESS = _address.trim();
      const RULE_1 = {
        expression: !ADDRESS || ADDRESS === "",
        name: "address",
        msg: this.$i18n.t("public.views.signUp.errors.erAddress"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkMemberId(_memberId) {
      const MEMBERID = _memberId.trim();
      const RULE_1 = {
        expression: !MEMBERID || MEMBERID === "",
        name: "memberId",
        msg: this.$i18n.t("public.views.signUp.errors.erMemberId"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkAcceptConditions(_acceptConditions) {
      const ACCEPTCONDITIONS = _acceptConditions;
      const RULE_1 = {
        expression: ACCEPTCONDITIONS === "false",
        name: "acceptConditions",
        msg: this.$i18n.t("public.views.signUp.errors.erAcceptConditions"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkTimeZone(_timeZone) {
      const TIMEZONE = _timeZone.trim();
      const RULE_1 = {
        expression: !TIMEZONE || TIMEZONE === "",
        name: "timeZone",
        msg: this.$i18n.t("public.views.signUp.errors.erTimeZone"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkFormStep1() {
      this.checkEmail(this.email, this.emailInUse);
      this.checkPassword(this.password);
      this.checkPasswordConfirm(this.passwordConfirm, this.password);
    },
    cleanFormStep1() {
      this.emailInUse = false;
      this.email = "";
      this.password = "";
      this.passwordConfirm = "";
      this.validatorStep1.errors = [];
    },
    saveFormStep1() {
      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        //Call service to store data
        this.getFile(this.uuid);
        this.$bvModal.show("modal-register");
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t("public.views.signUp.errors.erTitle"),
          text: this.$i18n.t("public.views.signUp.errors.erStep1"),
          type: "error",
        });
      }
    },
    checkFormStep2() {
      this.checkName(this.name);

      this.checkLastname(this.lastname);

      this.checkDocument(this.document);
      this.checkAcceptConditions(this.acceptConditions);

      //this.checkLanguage(this.language);
      //this.checkPhone(this.phone);
      this.checkCountry(this.country);
      this.checkAddress(this.address);
      this.checkMemberId(this.memberId);
      //this.checkTimeZone(this.timeZone);
    },
    cleanFormStep2() {
      this.name = "";
      this.lastname = "";
      this.document = "";
      this.language = "sp";
      this.phone = "";
      this.phoneVuePhoneNumberInput = "";
      this.country = "";
      this.address = "";
      this.timeZone = "Europe/Brussels";
      this.uuid = "";
      this.filename = "";
      this.currency = "EUR";
      this.memberId = "";
      this.acceptConditions = false;
      this.validatorStep2.errors = [];
    },
    saveFormStep2(evt) {
      evt.preventDefault();
      this.checkFormStep2();
      if (this.validatorStep2.errors.length === 0) {
        //Call service to store data

        this.recaptcha();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t("public.views.signUp.errors.erTitle"),
          text: this.$i18n.t("public.views.signUp.errors.erStep2"),
          type: "error",
        });
      }
    },
    getCheckEmail(email) {
      let self = this;
      utilsService
        .checkEmail(email)
        .then((response) => {
          if (response) {
            self.emailInUse = response.data;
            self.checkEmail(this.email, response.data);
          }
        })
        .catch(function (error) {
          if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        });
    },
    createProfessional() {
      let professional = {
        email: this.email,
        password: this.password,
        passwordConfirm: this.passwordConfirm,
        tokenRecaptcha: this.tokenRecaptcha,
        //--
        //Form modal
        name: this.name,
        lastname: this.lastname,
        document: this.document,
        language: this.language,
        address: this.address,
        phone: this.phone,
        country: this.country,
        timeZone: this.timeZone,
        uuid: this.uuid,
        filename: this.filename,
        currency: this.currency,
        memberId: this.memberId,
      };

      this.$awn.asyncBlock(
        professionalService.create(professional),
        (response) => {
          if (response) {
            routes.push({
              name: "public.signin",
              query: { checkMail: true },
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.create",
            module: "view-authpages-signUp",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: professional
            })
          });
        },
        " "
      );
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.address = placeResultData.formatted_address;
      this.country = addressData.country;
    },
    updateAddress(data) {
      this.address = data.newVal;
    },
    vdropzoneSuccess(file, response) {
      this.uuid = response.uuid;
      this.filename = response.name;
      this.getFile(response.uuid);
    },
    getFile(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.defaultAvatar = false;
            self.file = response.data.data;
          } else {
            self.defaultAvatar = true;
            self.file = require("../../assets/images/user/woman_profile.jpg");
          }
        })
        .catch(function (error) {
          self.defaultAvatar = true;
          self.file = require("../../assets/images/user/woman_profile.jpg");
        });
    },
    updatePhone(data) {
      this.phone = data.e164;
    },
  },
};
</script>
